import React from "react";

// Customizable Area Start
import {
  Box,
  Button, Typography,
} from "@mui/material";
import { apple, google, Applogo, twitter, linkdin, facebook, email, phone } from "./assets";

import FooterController, {
  Props,
} from "./FooterController";


export default class Footer extends FooterController {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { footerData } = this.props;
    return (
      
      <Box
        sx={{
          px: { xs: 2, sm: 6, md: 10 },
          py: 3,
          backgroundColor: "#000000",
        }}
      >
        <Box sx={{ py: 6 }}></Box>

        <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: { xs: 2, sm: 3, md: 4 },
    px: { xs: 2, sm: 6, md: 10 },
  }}
>
  {/* Logo + QR Code */}
  <Box sx={{ flex: "1 1 220px", maxWidth: "240px", textAlign: { xs: "center", sm: "left" } }}>
    <Box
      component="img"
      src={Applogo}
      alt="HubbleMeet Logo"
      sx={{ width: "300px", mb: 3, mt: -3, ml:-2 }}
    />
    <Box sx={{ display: "flex", justifyContent: { xs: "center", sm: "flex-start" }, ml: 2.5 }}>
      <Button sx={{ ...webStyle.qrCode }}>
        <img
          src={footerData.data.footer_image_url}
          alt="QR Code"
          style={{ width: "100%" }}
        />
      </Button>
    </Box>
    <Box
    sx={{
      display: 'flex',
      justifyContent: 'center', 
      alignItems: 'center',
      ml: 2.5,
    }}
    >
    <Typography
      sx={{
        letterSpacing: "-0.5%",
        fontSize: "18px",
        fontWeight: "500",
        lineHeight: "32px",
        fontFamily: "'Inter', sans-serif",
        color: "#fff",
        mt: 1,
        textAlign: "center",
        whiteSpace: 'nowrap',
      }}
    >
      Scan here to download the app
    </Typography>
    </Box>
  </Box>

  {/* Navigation Links */}
  <Box sx={{ flex: "1 1 160px", maxWidth: "180px", textAlign: { xs: "center", sm: "left" }, display: "flex", flexDirection: "column", gap: "32px" }}>
    <Typography data-test-id="home-link" onClick={this.scrollToHome} sx={{ ...webStyle.footerLinks, cursor: "pointer" }}>Home</Typography>
    <Typography data-test-id="connect-link" onClick={this.scrollToConnect} sx={{ ...webStyle.footerLinks, cursor: "pointer" }}>Connect</Typography>
    <Typography data-test-id="pitch-link" onClick={this.scrollToPitch} sx={{ ...webStyle.footerLinks, cursor: "pointer" }}>Pitch</Typography>
  </Box>

  {/* Contact Info */}
<Box
  sx={{
    flex: "1 1 180px",
    maxWidth: "200px",
    textAlign: { xs: "center", sm: "left" },
    display: "flex",
    flexDirection: "column",
    gap: 3,
  }}
>
  <Typography sx={{...webStyle.footerLinks, cursor:"none"}}>Contact Us</Typography>
<Box 
sx={{
  display: "flex",
  flexDirection: "column",
  gap: 2,
}}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: { xs: "center", sm: "flex-start" },
      gap: 2,
    }}
  >
    <Box
      component="img"
      src={email}
      alt="Email Icon"
      sx={{ width: 20, height: 20, alignSelf: "center", }}
    />
    <Typography 
    sx={{
              ...webStyle.footerLinks,
              marginBottom: 0,
              lineHeight: "82%",
              cursor: "none",
            }}
    >{footerData.data.email}</Typography>
  </Box>
 
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: { xs: "center", sm: "flex-start" },
      gap: 2,
    }}
  >
    <Box
      component="img"
      src={phone}
      alt="Phone Icon"
      sx={{ width: 20, height: 20 }}
    />
    <Typography 
    sx={{
               ...webStyle.footerLinks,
               marginBottom: 0,
               lineHeight: "82%",
               whiteSpace: 'nowrap',
               cursor: "none",
            }}
    >{footerData.data.phone}</Typography>
  </Box>
</Box>
</Box>

  {/* Download Links */}
  <Box sx={{ flex: "1 1 180px", maxWidth: "200px", textAlign: { xs: "center", sm: "left" }, display: "flex", flexDirection: "column", alignItems: { xs: "center", sm: "flex-start" }, gap: 1 }}>
    <Typography sx={{...webStyle.footerLinks, cursor:"none"}}>Download Link</Typography>
    <img src={google} alt="Google Play" style={webStyle.downloadLinks} />
    <img src={apple} alt="Apple Store" style={webStyle.downloadLinks} />
  </Box>

                      {/* Social Media */}
          <Box sx={{ flex: "1 1 180px", maxWidth: "200px", textAlign: { xs: "center", sm: "left" }, display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography sx={{...webStyle.footerLinks, whiteSpace: 'nowrap', cursor: "none"}}>Social Networks</Typography>
            {footerData.data?.social_links?.facebook && (
              <Button onClick={() => window.open(footerData.data.social_links.facebook, '_blank')} sx={webStyle.socialButton}>
                <img src={facebook} alt="Facebook" style={{ marginRight: 8, width: 24 }} />Facebook
              </Button>
            )}
            {footerData.data?.social_links?.instagram && (
              <Button onClick={() => window.open(footerData.data.social_links.instagram, '_blank')} sx={webStyle.socialButton}>
                <img src={facebook} alt="Instagram" style={{ marginRight: 8, width: 24 }} />Instagram
              </Button>
            )}
            {footerData.data?.social_links?.twitter && (
              <Button onClick={() => window.open(footerData.data.social_links.twitter, '_blank')} sx={webStyle.socialButton}>
                <img src={twitter} alt="Twitter" style={{ marginRight: 8, width: 24 }} />Twitter
              </Button>
            )}
            {footerData.data?.social_links?.linkedin && (
              <Button onClick={() => window.open(footerData.data.social_links.linkedin, '_blank')} sx={webStyle.socialButton}>
                <img src={linkdin} alt="LinkedIn" style={{ marginRight: 8, width: 24 }} />LinkedIn
              </Button>
            )}
          </Box>
</Box>


        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            mt: 4,
            py: 3,
            mr: 9,
          }}
        >
          <Box>
          <Typography sx={{ marginLeft: "20px", fontSize: "24.36px", lineHeight: "150%", fontWeight: "400", fontFamily: "var(--font-family-roboto)", color: "#fff", letterSpacing: "0%" }}>Copyrights © HubbleMeet 2025</Typography>
          </Box>
          <Box
    sx={{
      display: "flex",
      gap: "60px",
    }}
  >
    <Typography data-test-id="privacy-policy" onClick={this.handlePrivacyPolicyClick} sx={{ letterSpacing: "0%", fontSize: "24.36px", lineHeight: "150%", fontWeight: 400, fontFamily: "var(--font-family-roboto)", color: "#fff", cursor: "pointer" }}>Privacy Policy</Typography>
    <Typography data-test-id="terms-conditions"onClick={this.handleTermsConditionsClick} sx={{ letterSpacing: "0%", fontSize: "24.36px", lineHeight: "150%", fontWeight: 400, fontFamily: "var(--font-family-roboto)", color: "#fff", cursor: "pointer" }}>Terms & Conditions</Typography>
  </Box>
        </Box>
      </Box>
    );
  }
}
// Customizable Area End
// Customizable Area Start
const webStyle = {
  footer: {
    backgroundColor: "red",
    color: "#fff",
  },
  qrSection: {
    textAlign: "center",
  },
  qrCode: {
    maxWidth: "238px",
    width: "100%",
  },
  navLinks: {
    textAlign: "left",
  },
  socialIcons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  downloadLinks: {
    maxWidth: "196",
    width: "100%",
    marginBottom: "12px",
    cursor: "pointer"
  },
  socialButton: {
    rowGap: "12px",
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "25px",
    textTransform: "none",
    display: "flex",
    borderRadius: "50px",
    padding: "9px",
    margin: "4px",
    color: "#fff",
    maxWidth: "196",
    width: "100%",
    backgroundColor: "#292524",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  footerLinks: {
    fontFamily: "var(--font-family-roboto)",
    color: "#fff",
    fontSize: "24px",
    fontWeight: "600",
    lineHeight: "82%",
    marginBottom: "22px",
    letterSpacing: "0%",
    listSpacing: "24px",
    cursor: "pointer"
  },
  footerLinksHome: {
    fontSize: "24px",
    fontWeight: "600",
    fontFamily: "'Roboto', sans-serif",
    lineHeight: "82%",
    listSpacing: "24px",
    letterSpacing: "0%",
    marginBottom: "32px",
    cursor: "pointer"
  }
}
// Customizable Area End
